import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
import { PostMessageManager } from "#webapp/src/util/post-message.util";
import { useMutation } from "@apollo/client";
import { useGatewayMutation } from "@clockwise/web-commons/src/network/apollo/gateway-provider";
import { keys } from "lodash";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";

const SingleUseMutationExtListener = ({
  options,
  mutation,
  mutationId,
  mutationCallId,
}: {
  options?: any;
  mutation: any;
  mutationId: string;
  mutationCallId: number;
}) => {
  // Inferred Types don't work here, but we don't need it to!
  const [_mutation, { loading, data, error }] = useMutation(mutation, options);

  useEffect(() => {
    try {
      _mutation();
    } catch (errorResponse) {
      PostMessageManager.sendCommitApolloMutation(mutationId, {
        data,
        loading: false,
        error: errorResponse,
      });
    }
  }, [JSON.stringify(mutation), JSON.stringify(options), mutationId, mutationCallId]);

  useEffect(() => {
    PostMessageManager.sendCommitApolloMutation(mutationId, { data, loading, error });
  }, [mutationId, data, loading, error]);

  return null;
};

const SingleUseGatewayMutationExtListener = ({
  options,
  mutation,
  mutationId,
  mutationCallId,
}: {
  options?: any;
  mutation: any;
  mutationId: string;
  mutationCallId: number;
}) => {
  // Inferred Types don't work here, but we don't need it to!
  const [_mutation, { loading, data, error }] = useGatewayMutation(mutation, options);

  useEffect(() => {
    try {
      _mutation();
    } catch (errorResponse) {
      PostMessageManager.sendCommitApolloMutation(mutationId, {
        data,
        loading: false,
        error: errorResponse,
      });
    }
  }, [JSON.stringify(mutation), JSON.stringify(options), mutationId, mutationCallId]);

  useEffect(() => {
    PostMessageManager.sendCommitApolloMutation(mutationId, { data, loading, error });
  }, [mutationId, data, loading, error]);

  return null;
};

const UseMutationExtListener = () => {
  const activeMutationCollection = useSelector(
    (state: IReduxState) => state.webExtension.activeMutationCollection,
  );

  return (
    <div id="use-mutation-ext-listener">
      {keys(activeMutationCollection).map((mutationId) => {
        const { options, mutation, mutationCallId, type } = activeMutationCollection[mutationId];

        return type === "gateway" ? (
          <SingleUseGatewayMutationExtListener
            options={options}
            mutation={mutation}
            mutationId={mutationId}
            key={mutationId}
            mutationCallId={mutationCallId}
          />
        ) : (
          <SingleUseMutationExtListener
            options={options}
            mutation={mutation}
            mutationId={mutationId}
            key={mutationId}
            mutationCallId={mutationCallId}
          />
        );
      })}
    </div>
  );
};

export default UseMutationExtListener;
